import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  /**
   * The Razorpay sidecart replaces this drawer, so it must never be shown. It cannot
   * simply be hidden in CSS: the dialog still opens and scroll-locks the page behind a
   * panel the shopper can neither see nor close. Third parties call open() on it —
   * the Reelfy shoppable-video widget does so after its add-to-cart — so neutralise
   * showDialog() rather than any single caller.
   *
   * The element itself stays rendered: the header cart icon lives inside it and carries
   * the sidecart's data-rzp-cart-icon hook. Hiding the element hides the cart icon too.
   */
  showDialog() {}

  open() {}

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
